import {Message} from "element-ui";
import store from '@/store'

// 检测是否为Json对象，清空输入框内容
export function clearInputContent(str) {
    // console.log(typeof(JSON.parse(str)))
    // try{
    //     if(typeof JSON.parse(str) === 'object'){
    //         for(let key in str){
    //             str[key] = ''
    //         }
    //     }
    // }catch(e){}
    // return false;
    for (let key in str) {
        str[key] = ''
    }
}

// 时间转换
export function dateFilter(time) {
    if (!time) {
        return ''
    } else {
        const date = new Date(time);
        const dateNumFun = (num) => num < 10 ? `0${num}` : num;
        const [Y, M, D, h, m, s] = [
            date.getFullYear(),
            dateNumFun(date.getMonth() + 1),
            dateNumFun(date.getDate()),
            dateNumFun(date.getHours()),
            dateNumFun(date.getMinutes()),
            dateNumFun(date.getSeconds())
        ]
        return `${Y}-${M}-${D} ${h}:${m}:${s}`
    }
}

// 判断权限
export function hasBtnPermission(permission) {
    const buttonList = store.state.menuList;
    return JSON.stringify(buttonList).indexOf(permission) > -1
}

// 数组去重
export function unique(arr) {
    return Array.from(new Set(arr))
}

// 分流函数
function timeChunk(array, fn, step = 1, interval = 200) {
    let time;

    function start() {
        for (let i = 0; i < Math.min(step, array.length); i++) {
            console.log("业务函数激活一次");
            fn(array.shift());
        }
    }

    return function () {
        timer = setInterval(() => {
            array.length === 0 ? clearInterval(timer) : start()
        }, interval);
    }
}


/**
 * 防抖
 * @param {Function} func 要执行的回调函数
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 * @return null
 */
let timeout;
export function debounce(func, wait=300, immediate = false) {
    // 清除定时器
    if (timeout !== null) clearTimeout(timeout);
    // 立即执行，此类情况一般用不到
    if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(function() {
            timeout = null;
        }, wait);
        if (callNow) typeof func === 'function' && func();
    } else {
        // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
        timeout = setTimeout(function() {
            typeof func === 'function' && func();
        }, wait);
    }
}


export default {
    clearInputContent,
    dateFilter,
    hasBtnPermission,
    unique,
    timeChunk,
    debounce,
};
